import * as httpUtil from "@/utils/httpUtil";

const interfaces: Array<Record<string, any>> = [
  { method: "post", name: "shopDetail", url: "/c/pc/community/shop/detail", desc: "详情" },
  {
    method: "post",
    name: "shopSave",
    url: "/c/pc/community/shop/save",
    desc: "新增/修改",
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
